<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>

<mat-card class="alarms-widget-card">
  <mat-card-title *ngIf="!changeTitle; else editTitleWidget">
    <ng-container *ngIf="widget && !widget.meta.hideTitle"> {{ widget.name }} </ng-container>
    <ng-container *ngIf="!widget || widget.meta.hideTitle"> {{ 'common.alerts' | t }} </ng-container>
    <sn-icon
      *ngIf="widget"
      size="xs"
      [matTooltip]="'common.editTitle' | t"
      matTooltipPosition="above"
      (click)="editTitle()"
      >edit</sn-icon
    >
    <div class="checkbox-container">
      <mat-checkbox [checked]="true" [formControl]="showClosed">{{ 'dashboard.operational.widgets.showClosed' | t }} </mat-checkbox>
    </div>
    <div>
      <button
        mat-icon-button
        class="menuBtn"
        color="accent"
        [matTooltip]="'common.filters' | t"
        [matMenuTriggerFor]="beforeMenu"
      >
        <sn-icon>sort</sn-icon>
      </button>
    </div>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="filterAndFetchAlarm(null, null)">{{ 'common.all' | t }}</button>
      <button
        *ngFor="let type of types"
        mat-menu-item
        (click)="filterAndFetchAlarm(type.name, type.id); paginator.pageIndex = 0"
      >
        {{ type.name }}
      </button>
    </mat-menu>
  </mat-card-title>
  <mat-card-content>
    <div class="loadingOverlay" *ngIf="isLoadingResults && !data?.length">
      <mat-progress-spinner
        class="center-horizontally"
        color="accent"
        diameter="48"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
    <mat-table
      [dataSource]="data"
      multiTemplateDataRows
      matSort
      matSortActive="createdAt"
      matSortDisableClear
      matSortDirection="desc"
    >
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.type' | t }}</mat-header-cell>
        <mat-cell *matCellDef="let alarm">{{ alarm.type }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="message">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.message' | t }}</mat-header-cell>
        <mat-cell *matCellDef="let alarm">
          <ng-template [ngIf]="alarm.type === 'RT ALPR'" [ngIfElse]="alarmMsg">
            {{ alarm.details['reason'] }}
          </ng-template>
          <ng-template #alarmMsg>
            {{ alarm.message }}
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'dashboard.operational.widgets.originDate' | t }}</mat-header-cell>
        <mat-cell *matCellDef="let alarm">{{ alarm.createdAt | fsFormatDate : 'medium' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="alarmView">
        <mat-cell *matCellDef="let alarm" [attr.colspan]="displayedColumns.length">
          <div class="detail" [@snDetailExpand]="isExpanded(alarm.id) ? 'expanded' : 'collapsed'">
            <div class="detail-container">
              <sn-alarm-card
                *ngIf="isExpanded(alarm.id)"
                [alarm]="alarm"
                class="default-card"
              ></sn-alarm-card>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        matRipple
        [class.closed]="alarm.status === 'Closed'"
        [class.active]="isExpanded(alarm.id)"
        (click)="toggleExpanded(alarm.id)"
        *matRowDef="let alarm; columns: displayedColumns"
      >
      </mat-row>
      <mat-row *matRowDef="let row; columns: ['alarmView']" class="detail-row"></mat-row>
    </mat-table>

    <div class="empty" *ngIf="!isLoadingResults && !data?.length">
      <p>{{ 'dashboard.operational.widgets.noAlertsFound' | t }}</p>
    </div>
  </mat-card-content>
  <mat-paginator #paginator [pageSize]="5" [length]="resultsLength"></mat-paginator>
</mat-card>
